<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vx-card title="Информация о доме" class="text-lg">
          <div slot="actions">
            <vs-button
              v-if="$can('rp.main', 'write')" class="ml-2" @click="isEditHouseInfo = true" iconPack="feather"
              icon="icon-edit" type="border" title="Редактировать"
            />
          </div>

          <div class="vx-row">
            <div
              class="vx-col md:flex-1 w-full"
              v-if="house.city || house.street || house.house || house.corpus || house.stroenie || house.num_floor || house.num_pod || house.num_kv || house.type_house"
            >
              <div class="vx-row">
                <div
                  class="vx-col w-full mb-base"
                  v-if="house.city || house.street || house.house || house.corpus || house.stroenie"
                >
                  <p class="leading-relaxed" v-if="house.city"><span class="font-medium">Город:</span> {{ house.city }}
                  </p>
                  <p class="leading-relaxed" v-if="house.street"><span class="font-medium">Улица:</span>
                    {{ house.street }}</p>
                  <p class="leading-relaxed" v-if="house.house"><span class="font-medium">Дом:</span> {{ house.house }}
                  </p>
                  <p class="leading-relaxed" v-if="house.corpus"><span class="font-medium">Корпус:</span>
                    {{ house.corpus }}</p>
                  <p class="leading-relaxed" v-if="house.stroenie"><span class="font-medium">Строение:</span>
                    {{ house.stroenie }}</p>
                </div>
                <div
                  class="vx-col w-full mb-base"
                  v-if="house.num_floor || house.num_pod || house.num_kv || house.type_house"
                >
                  <p class="leading-relaxed" v-if="house.num_floor"><span class="font-medium">Этажей:</span>
                    {{ house.num_floor }}</p>
                  <p class="leading-relaxed" v-if="house.num_pod"><span class="font-medium">Подъездов:</span>
                    {{ house.num_pod }}</p>
                  <p class="leading-relaxed" v-if="house.num_kv"><span class="font-medium">Квартир:</span>
                    {{ house.num_kv }}</p>
                  <p class="leading-relaxed" v-if="house.type_house"><span class="font-medium">Тип дома:</span>
                    {{ houseTypes[house.type_house] ? houseTypes[house.type_house].label : '' }}</p>
                </div>
              </div>
            </div>
            <div class="vx-col md:flex-1 w-full">
              <div
                class="vx-col w-full mb-base"
                v-if="house.water_system !== null || house.gaz !== null || house.electric_cooker !== null || house.heating !== null || house.type_hot_water !== null"
              >
                <p class="leading-relaxed" v-if="house.water_system !== null"><span
                  class="font-medium"
                >Водопровод:</span> {{ house.water_system === true ? 'есть' : 'нет' }}</p>
                <p class="leading-relaxed" v-if="house.gaz !== null"><span class="font-medium">Газификация:</span>
                  {{ house.gaz === true ? 'есть' : 'нет' }}</p>
                <p class="leading-relaxed" v-if="house.electric_cooker !== null"><span
                  class="font-medium"
                >Электроплиты:</span> {{ house.electric_cooker === true ? 'да' : 'нет' }}</p>
                <p class="leading-relaxed" v-if="house.heating !== null"><span class="font-medium">Тип отопления:</span>
                  {{ heatingTypes[house.heating] ? heatingTypes[house.heating].label : '' }}</p>
                <p class="leading-relaxed" v-if="house.type_hot_water !== null">
                  <span class="font-medium">Тип ГВС:</span>
                  {{ hotWaterTypes[house.type_hot_water] ? hotWaterTypes[house.type_hot_water].label : '' }}
                </p>
              </div>
              <div class="vx-col w-full mb-base">
                <p class="leading-relaxed"><span class="font-medium">Дата постройки: </span> <span
                  v-if="house.date_construct"
                >{{ house.date_construct | moment }}</span><span v-else>нет</span></p>
                <p class="leading-relaxed"><span class="font-medium">Дата капремонта: </span> <span
                  v-if="house.date_repair"
                >{{ house.date_repair | moment }}</span><span v-else>нет</span></p>
                <p class="leading-relaxed"><span class="font-medium">Ввод в эксплуатацию: </span> <span
                  v-if="house.date_start_maintenance"
                >{{ house.date_start_maintenance | moment }}</span><span
                  v-else
                >нет</span></p>
              </div>
            </div>
            <div
              class="vx-col md:flex-1 w-full"
              v-if="house.area_all || house.area_living || house.area_notliving || house.area_heat || house.area_medium || house.area_cleaning_land || house.area_cleaning_stairs"
            >
              <div
                class="vx-col w-full mb-base"
                v-if="house.area_all || house.area_living || house.area_notliving || house.area_heat || house.area_medium"
              >
                <p class="leading-relaxed"><span class="font-medium">Площадь жилых и нежилых помещений (м2):</span>
                  {{ house.area_all }}</p>
                <p class="leading-relaxed"><span class="font-medium">Площадь жилых помещений (м2):</span>
                  {{ house.area_living }}</p>
                <p class="leading-relaxed"><span class="font-medium">Площадь нежилых помещений (м2):</span>
                  {{ house.area_notliving }}</p>
                <p class="leading-relaxed"><span class="font-medium">Отапливаемая площадь (м2):</span>
                  {{ house.area_heat }}</p>
                <p class="leading-relaxed"><span class="font-medium">Средняя площадь (м2):</span>
                  {{ house.area_medium }}
                </p>
                <p class="leading-relaxed"><span class="font-medium">Площадь МОП (м2):</span> {{ house.area_common }}
                </p>
                <p class="leading-relaxed"><span class="font-medium">Площадь МОП для расчета ХВС/ГВС СОИ (м2):</span>
                  {{ house.area_common_calc }}</p>
              </div>
              <div class="vx-col w-full mb-base" v-if="house.area_cleaning_land || house.area_cleaning_stairs">
                <p class="leading-relaxed"><span class="font-medium">Уборочная площадь з. участка (м2):</span>
                  {{ house.area_cleaning_land }}</p>
                <p class="leading-relaxed"><span class="font-medium">Уборочная площадь лестнниц (м2):</span>
                  {{ house.area_cleaning_stairs }}</p>
              </div>
            </div>

          </div>
        </vx-card>

        <UCContacts :building-id="selectedHouseId" />

        <vx-card title="Дополнительные адреса" class="text-lg mt-4">
          <div slot="actions">
            <vs-button
              v-if="$can('rp.main', 'write')"
              class="ml-2"
              @click="onEditAdditionalAdresses"
              iconPack="feather"
              icon="icon-edit"
              type="border"
              title="Редактировать"
            />
          </div>
          <ul v-if="Array.isArray(additionalAddresses) && additionalAddresses.length">
            <li v-for="(address, key) in additionalAddresses" :key="key">{{ address }}</li>
          </ul>
          <div v-else>-</div>
        </vx-card>
      </div>
    </div>
    <template>
      <div class="vx-row mb-4" v-show="$can('rp.devices')">
        <div class="vx-col w-full">
          <vx-card title="Общедомовые приборы учета">
            <div slot="actions" class="flex items-center">
              <!--              <vs-button v-if="$can('rp.devices', 'write')" key="button-1" class="ml-2"-->
              <!--                         @click="isAddMeteringDevice = true" iconPack="feather" icon="icon-plus" type="border"-->
              <!--                         title="Добавить"/>-->
              <!--              <vs-button v-if="$can('rp.devices', 'write')" key="button-2" class="ml-2"-->
              <!--                         @click="isEditMeteringDevice = true" iconPack="feather" icon="icon-edit" type="border"-->
              <!--                         title="Редактировать"/>-->
            </div>

            <div style="display: flex; flex-direction: column">
              <ag-grid-table
                ref="table"
                :getData="updateDevices"
                :columns="columnDefs"
                no-data-text="Общедомовых приборов нет"
                auto-height
              />
            </div>
          </vx-card>
        </div>
      </div>


      <vs-popup title="Добавление прибора учета" :active.sync="isAddMeteringDevice" class="overflow-hidden">
        <form class="w-full overflow-hidden">
          <div class="vx-col w-full">
            <label for="newMetering-type">Тип прибора</label>
            <vs-select class="w-full mb-3" v-model="newMeteringDevice.type" id="newMetering-type">
              <vs-select-item
                :key="deviceType.id" :value="deviceType.id" :text="deviceType.name"
                v-for="deviceType in deviceTypesForNew"
              />
            </vs-select>

            <div class="vx-row" v-if="newMeteringDevice.type === electricityId">
              <div class="vx-col w-full md:w-auto mb-3 flex wrap">
                <vs-radio
                  v-model="newMeteringDevice.electricity_meter" :vs-value="electricityTypes.single"
                  class="mr-2"
                >Однотарифный
                </vs-radio>
              </div>
              <div class="vx-col w-full lg:w-auto mb-3 flex wrap">
                <vs-radio
                  v-model="newMeteringDevice.electricity_meter" :vs-value="electricityTypes.double"
                  class="mr-2"
                >Двухтарифный
                </vs-radio>
              </div>
              <div class="vx-col w-full lg:w-auto mb-3 flex wrap">
                <vs-radio
                  v-model="newMeteringDevice.electricity_meter" :vs-value="electricityTypes.triple"
                  class="mr-2"
                >Трёхтарифный
                </vs-radio>
              </div>
            </div>
          </div>
          <div class="vx-col w-full mb-3">
            <label for="newMetering-deviceName">Название</label>
            <vs-input class="w-full" v-model="newMeteringDevice.device_name" id="newMetering-deviceName" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="newMetering-factoryNumber">Номер</label>
            <vs-input class="w-full" v-model="newMeteringDevice.factory_number" id="newMetering-factoryNumber" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="newMetering-operationActNumber">Номер акта ввода в эксплуатацию</label>
            <vs-input
              class="w-full" v-model="newMeteringDevice.operation_act_number"
              id="newMetering-operationActNumber"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="newMetering-operationStartDate">Дата начала эксплуатации</label>
            <datepicker
              class="w-full" :language="ru" format="dd.MM.yyyy"
              v-model="newMeteringDevice.operation_start_date" id="newMetering-operationStartDate"
              style="position: unset;"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="newMetering-nextCheckingDate">Дата следующей поверки</label>
            <datepicker
              class="w-full" :language="ru" format="dd.MM.yyyy" v-model="newMeteringDevice.next_checking_date"
              id="newMetering-nextCheckingDate" style="position: unset;"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="newMetering-sealNumber">Номер пломбы</label>
            <vs-input class="w-full" v-model="newMeteringDevice.seal_number" id="newMetering-sealNumber" />
          </div>
          <div class="vx-col w-full flex justify-center">
            <vs-button type="filled" color="primary" @click.prevent="addMeteringDevice">Добавить</vs-button>
          </div>
        </form>
      </vs-popup>

      <vs-popup title="Реадактирование прибора учета" :active.sync="isEditMeteringDevice" v-if="currentMeteringDevice">
        <form class="w-full overflow-hidden">
          <div class="vx-col w-full mb-3">
            <label for="editMetering-type">Тип прибора</label>
            <vs-select class="w-full" v-model="currentMeteringDevice.type" id="editMetering-type">
              <vs-select-item
                :key="deviceType.id" :value="deviceType.id" :text="deviceType.name"
                v-for="deviceType in deviceTypes"
              />
            </vs-select>
          </div>
          <div class="vx-col w-full mb-3">
            <label for="editMetering-deviceName">Название</label>
            <vs-input class="w-full" v-model="currentMeteringDevice.device_name" id="editMetering-deviceName" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="editMetering-factoryNumber">Номер</label>
            <vs-input class="w-full" v-model="currentMeteringDevice.factory_number" id="editMetering-factoryNumber" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="editMetering-operationActNumber">Номер акта ввода в эксплуатацию</label>
            <vs-input
              class="w-full" v-model="currentMeteringDevice.operation_act_number"
              id="editMetering-operationActNumber"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="editMetering-operationStartDate">Дата начала эксплуатации</label>
            <datepicker
              class="w-full" :language="ru" format="dd.MM.yyyy"
              v-model="currentMeteringDevice.operation_start_date" id="editMetering-operationStartDate"
              style="position: unset;"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="editMetering-nextCheckingDate">Дата следующей поверки</label>
            <datepicker
              class="w-full" :language="ru" format="dd.MM.yyyy"
              v-model="currentMeteringDevice.next_checking_date" id="editMetering-nextCheckingDate"
              style="position: unset;"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="editMetering-sealNumber">Номер пломбы</label>
            <vs-input class="w-full" v-model="currentMeteringDevice.seal_number" id="editMetering-sealNumber" />
          </div>
          <div class="vx-col w-full flex justify-center">
            <vs-button type="filled" color="danger" @click.prevent="deleteMeteringDevice" class="mt-4 mr-4">Удалить
            </vs-button>
            <vs-button type="filled" color="primary" @click.prevent="editMeteringDevice" class="mt-4 mr-4">Изменить
            </vs-button>
          </div>
        </form>
      </vs-popup>
    </template>

    <div class="vx-row">
      <div class="vx-col w-full">
        <DocumentsPanel type="house" :buildingsId="selectedHouseId" />
      </div>
    </div>

    <vs-popup
      title="Редактирование информации о доме" :active.sync="isEditHouseInfo" class="house-edit-popup"
      v-if="$can('rp', 'write')"
    >
      <div class=""></div>
      <form class="w-full overflow-hidden vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-city">Город</label>
            <vs-input v-model="editingHouseInfo.city" class="w-full" id="houseInfo-city" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-street">Улица</label>
            <vs-input v-model="editingHouseInfo.street" class="w-full" id="houseInfo-street" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-house">Номер дома</label>
            <vs-input v-model="editingHouseInfo.house" class="w-full" id="houseInfo-house" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-corpus">Корпус</label>
            <vs-input v-model="editingHouseInfo.corpus" class="w-full" id="houseInfo-corpus" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-stroenie">Строение</label>
            <vs-input v-model="editingHouseInfo.stroenie" class="w-full" id="houseInfo-stroenie" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-numFloor">Этажей</label>
            <vs-input v-model="editingHouseInfo.num_floor" class="w-full" id="houseInfo-numFloor" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-numPod">Подъездов</label>
            <vs-input v-model="editingHouseInfo.num_pod" class="w-full" id="houseInfo-numPod" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-numKv">Квартир</label>
            <vs-input v-model="editingHouseInfo.num_kv" class="w-full" id="houseInfo-numKv" />
          </div>
          <div class="vx-col w-full mb-3">
            <elsa-v-select
              :options="houseTypes"
              v-model="editingHouseInfo.type_house"
              :reduce="item => item.id"
              :clearable="false"
              htmlLabel="Тип дома"
              styleType="largeLabel"
              :appendToBody="true"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <vs-checkbox v-model="editingHouseInfo.water_system">Водопровод</vs-checkbox>
          </div>
          <div class="vx-col w-full mb-3">
            <vs-checkbox v-model="editingHouseInfo.gaz">Газификация</vs-checkbox>
          </div>
          <div class="vx-col w-full mb-3">
            <vs-checkbox v-model="editingHouseInfo.electric_cooker">Электроплиты</vs-checkbox>
          </div>
          <div class="vx-col w-full mb-3">
            <elsa-v-select
              :options="heatingTypes"
              v-model="editingHouseInfo.heating"
              :reduce="item => item.id"
              :clearable="false"
              htmlLabel="Тип отопления"
              styleType="largeLabel"
              :appendToBody="true"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <elsa-v-select
              :options="hotWaterTypes"
              v-model="editingHouseInfo.type_hot_water"
              :reduce="item => item.id"
              :clearable="false"
              htmlLabel="Тип ГВС"
              styleType="largeLabel"
              :appendToBody="true"
            />
          </div>
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-dateConstruct">Дата постройки</label>
            <datepicker
              class="w-full" :language="ru" format="dd.MM.yyyy" v-model="editingHouseInfo.date_construct"
              id="houseInfo-dateConstruct" style="position: unset;"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-dateRepair">Дата капремонта</label>
            <datepicker
              class="w-full" :language="ru" format="dd.MM.yyyy" v-model="editingHouseInfo.date_repair"
              id="houseInfo-dateRepair" style="position: unset;"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-dateStartMaintenance">Ввод в эксплутацию</label>
            <datepicker
              class="w-full" :language="ru" format="dd.MM.yyyy"
              v-model="editingHouseInfo.date_start_maintenance" id="houseInfo-dateStartMaintenance"
              style="position: unset;"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-areaAll">Площадь жилых и нежилых помещений (м2):</label>
            <vs-input v-model="editingHouseInfo.area_all" class="w-full" id="houseInfo-areaAll" type="number" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-areaLiving">Площадь жилых помещений (м2):</label>
            <vs-input v-model="editingHouseInfo.area_living" class="w-full" id="houseInfo-areaLiving" type="number" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-areaNotLiving">Площадь нежилых помещений (м2):</label>
            <vs-input
              v-model="editingHouseInfo.area_notliving" class="w-full" id="houseInfo-areaNotLiving"
              type="number"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-areaHeat">Отапливаемая площадь (м2):</label>
            <vs-input v-model="editingHouseInfo.area_heat" class="w-full" id="houseInfo-areaHeat" type="number" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-mop">Площадь МОП (м2):</label>
            <vs-input v-model="editingHouseInfo.area_common" class="w-full" id="houseInfo-mop" type="number" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-mop-tarrif">Площадь МОП для расчета ХВС/ГВС СОИ (м2):</label>
            <vs-input
              v-model="editingHouseInfo.area_common_calc" class="w-full" id="houseInfo-mop-tarrif"
              type="number"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-areaMedium">Средняя площадь (м2):</label>
            <vs-input v-model="editingHouseInfo.area_medium" class="w-full" id="houseInfo-areaMedium" type="number" />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-areaCleaningLand">Уборочная площадь з. участка (м2):</label>
            <vs-input
              v-model="editingHouseInfo.area_cleaning_land" class="w-full" id="houseInfo-areaCleaningLand"
              type="number"
            />
          </div>
          <div class="vx-col w-full mb-3">
            <label for="houseInfo-areaCleaningStairs">Уборочная площадь лестнниц (м2):</label>
            <vs-input
              v-model="editingHouseInfo.area_cleaning_stairs" class="w-full" id="houseInfo-areaCleaningStairs"
              type="number"
            />
          </div>

        </div>
        <div class="vx-row justify-center w-full">
          <div class="vx-col">
            <vs-button color="primary" type="filled" @click.prevent="saveHouseInfo">Сохранить</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>

  </div>
</template>

<script>
import UCContacts       from "@/components/main/UCContacts";
import Datepicker       from 'vuejs-datepicker';
import { ru }           from 'vuejs-datepicker/dist/locale';
import _get             from 'lodash/get';
import ElectricityMixin from "@/mixins/changeDeviceTypesForElectricityMixins";
import DocumentsPanel   from "@/components/calculated-program/account/DocumentsPanel";


export default {
  name:       "Main",
  mixins:     [ElectricityMixin],
  components: {
    UCContacts,
    Datepicker,
    DocumentsPanel,
  },
  data() {
    return {
      isEditHouseInfo:            false,
      isAddMeteringDevice:        false,
      isEditMeteringDevice:       false,
      currentMeteringDevice:      null,
      currentMeteringDeviceIndex: null,
      ru:                         ru,
      newMeteringDevice:          {
        general:              true,
        type:                 null,
        device_name:          null,
        factory_number:       null,
        operation_act_number: null,
        operation_start_date: null,
        next_checking_date:   null,
        seal_number:          null,
        electricity_meter:    2,
      },
      commonMeteringDevices:      [],
      columnDefs:                 [
        {
          headerName:  'Тип',
          field:       'type',
          filter:      true,
          valueGetter: ( { data } ) => this.getDeviceTypesById(data.type),
        },
        {
          headerName: 'Название',
          field:      'device_name',
          filter:     true,
        },
        {
          headerName: 'Номер',
          field:      'factory_number',
          filter:     true,
        },
        {
          headerName: 'Номер акта ввода в эксплуатацию',
          field:      'operation_act_number',
          filter:     true,
        },
        {
          headerName:  'Дата начала эксплуатации',
          field:       'operation_start_date',
          filter:      true,
          valueGetter: ( { data } ) => this.$options.filters.moment(data.operation_start_date),
        },
        {
          headerName:  'Дата следующей поверки',
          field:       'next_checking_date',
          filter:      true,
          valueGetter: ( { data } ) => this.$options.filters.moment(data.next_checking_date),
        },
        {
          headerName: 'Номер пломбы',
          field:      'seal_number',
          filter:     true,
        },
      ],
      houseTypes:                 [
        { id: 0, label: 'блочный' },
        { id: 1, label: 'деревянный' },
        { id: 2, label: 'кирпично-монолитный' },
        { id: 3, label: 'кирпичный' },
        { id: 4, label: 'крупно-панельный' },
        { id: 5, label: 'монолитный' },
        { id: 6, label: 'панельный' },
        { id: 7, label: 'другое' },
      ],
      heatingTypes:               [
        { id: 0, label: 'автономная' },
        { id: 1, label: 'квартирное' },
        { id: 2, label: 'печное' },
        { id: 3, label: 'центральное' },
        { id: 4, label: 'отсутствует' },
      ],
      hotWaterTypes:              [
        { id: 0, label: 'отсутствует' },
        { id: 1, label: 'центральное' },
        { id: 2, label: 'индивидуальное' },
      ],
      deviceTypes:                [],
      house:                      {},
      editingHouseInfo:           {},
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    additionalAddresses() {
      return _get(this.house, ['additional_params', 'additional_address']);
    },
  },
  methods:  {
    async addMeteringDevice() {
      if (!this.$can('rp.devices', 'write')) return false;
      try {
        this.newMeteringDevice.buildings_id = this.selectedHouseId;
        await this.$http.post('devices', this.newMeteringDevice);
        this.updateDevicesInfo();
        this.isAddMeteringDevice = false;
        this.newMeteringDevice.type = null;
        this.newMeteringDevice.device_name = null;
        this.newMeteringDevice.factory_number = null;
        this.newMeteringDevice.operation_act_number = null;
        this.newMeteringDevice.operation_start_date = null;
        this.newMeteringDevice.next_checking_date = null;
        this.newMeteringDevice.seal_number = null;
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    rowSelected( event ) {
      this.isEditMeteringDevice = false;
      this.currentMeteringDevice = Object.assign({}, event.api.getSelectedNodes()[0].data);
      this.currentMeteringDeviceIndex = event.api.getSelectedNodes()[0].rowIndex;
    },
    async editMeteringDevice() {
      if (!this.$can('rp.devices', 'write')) return false;
      try {
        let body = Object.assign(this.currentMeteringDevice, { buildings_id: this.house.id });
        let { data } = await this.$http.put('devices/' + this.currentMeteringDevice.id, body);
        this.$set(this.commonMeteringDevices, this.currentMeteringDeviceIndex, data.device);
        this.currentMeteringDevice = null;
        this.isEditMeteringDevice = false;
        this.updateDevicesInfo();
        this.$vs.notify({ color: 'success', title: 'Успешное редактирование', text: 'Информация о приборе изменена' });
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    async promtDelete( { id } ) {
      if (!this.$can('rp.devices', 'write')) return false;
      try {
        await this.$http.delete('devices/' + id, {
          buildings_id: this.house.id,
        });
        this.currentMeteringDevice = null;
        this.isEditMeteringDevice = false;
        this.updateDevicesInfo();
        this.$vs.notify({ color: 'success', title: 'Успешное удаление', text: 'Прибор учета удален' });
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    deleteMeteringDevice() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите удалить?',
        acceptText: 'Удалить',
        cancelText: 'Отменить',
        accept:     this.promtDelete,
        parameters: { id: this.currentMeteringDevice.id },
      });
    },
    async updateHouseInfo() {
      try {
        let { data } = await this.$http.get('houses?id=' + this.selectedHouseId);
        this.house = data;
        this.editingHouseInfo = Object.assign({}, data);
      } catch (e) {
        this.house = {};
        this.editingHouseInfo = {};
      }
    },
    async updateDevicesInfo() {
      try {
        let { data } = await this.$http.get('devices?buildings_id=' + this.selectedHouseId + '&general');
        this.commonMeteringDevices = data;
      } catch (e) {
        this.commonMeteringDevices = [];
      }
    },
    async saveHouseInfo() {
      if (!this.$can('rp.main', 'write')) return;
      try {
        let body = Object.assign(this.editingHouseInfo, {
          buildings_id: this.editingHouseInfo.id,
        });

        let { data } = await this.$http.put('houses/' + this.editingHouseInfo.id, body);
        this.house = data.house;
        this.editingHouseInfo = Object.assign({}, data.house);
        this.isEditHouseInfo = false;
        this.$vs.notify({ color: 'success', title: 'Успешное редактирование', text: 'Информация о доме изменена' });
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    getDeviceTypes() {
      return new Promise(async resolve => {
        let { data } = await this.$http.get('devices_type');
        this.deviceTypes = data;
        this.restructureDeviceTypesForNew(data);
        resolve(data);
      });
    },
    getDeviceTypesById( id ) {
      let deviceType = this.deviceTypes.find(deviceType => deviceType.id === id);
      return deviceType ? deviceType.name : 'Неизвестное устройство';
    },
    resetDevicesTable() {
      this.$refs.table.updateRows();
    },
    updateDevices() {
      return new Promise(async ( resolve ) => {
        let { data } = await this.$http.get('devices?buildings_id=' + this.selectedHouseId + '&general');
        resolve(data);
      });
    },

    onEditAdditionalAdresses() {
      this.$modal.open({
        title:          'Редактирование доп. адресов',
        size:           'md',
        component:      () => import('@/components/BuildingAdditionalAddressesModal'),
        componentProps: {
          buildingId: this.selectedHouseId,
          addresses:  this.additionalAddresses,
        },
      }).result.then(
        () => this.updateHouseInfo(),
        () => {},
      );
    },
  },
  watch:    {
    selectedHouseId() {
      this.updateHouseInfo();
      this.resetDevicesTable();
    },
  },
  async mounted() {
    await this.getDeviceTypes();
    this.updateHouseInfo();
  },
};
</script>

<style lang="scss">
.house-edit-popup.con-vs-popup {
  .vs-popup {
    width: 900px;
  }
}
</style>
